import type { MediaSlotRow } from './mediaApi';
import { useBootstrap } from './BootstrapContext';

// MediaProvider itself has moved into BootstrapProvider (mounted once in
// Layout.tsx) so this and PageSeoContext.tsx share a single combined
// fetch instead of two separate ones. useMediaSlot stays here so existing
// call sites don't need to change.
export function useMediaSlot(key: string): MediaSlotRow | undefined {
  const { media } = useBootstrap();
  return media[key];
}
